import React from 'react'
import {
    ArrowBigDown,
    Building2,
    CalendarCheck2,
    ChevronDown,
    Kanban,
    Key,
    Phone,
    Plus,
    Presentation,
    Rocket,
    ShoppingCart,
    SquareCheckBig,
    Truck,
    UserCheck,
    Users
} from 'lucide-react'
import { Dropdown } from '../ui/dropdown/Dropdown'
import { DropdownItem } from '../ui/dropdown/DropdownItem'
import { useCreate } from '../../context/CreateRegisterContext'
import { useActivity } from '../../context/ActivityContext'
import { useBusiness } from '../../context/BusinessContext'

export const GlobalCreateButton: React.FC = () => {
    const [isOpen, setIsOpen] = React.useState(false)
    const { setOpenBusiness, setOpenContact, setOpenCompany, setOpenProduct, setOpenTask, setOpenEvent, setOpenCall } =
        useCreate()
    const { setCurrentTab: setCurrentTabBusiness, setCurrentStep } = useBusiness() //* currentTab => Cada negócio/pipeline
    const { setCurrentTab: setCurrentTabActivity } = useActivity() //? currentTab => Calendário, Tarefas, Eventos, Chamadas

    const toggleDropdown = () => {
        setIsOpen(!isOpen)
    }

    const closeDropdown = () => {
        setIsOpen(false)
    }

    return (
        <div className='relative'>
            <button
                onClick={toggleDropdown}
                className='relative flex items-center justify-center text-white transition-colors bg-brand-500 border border-brand-500 rounded-full hover:text-dark-900 h-11 w-11 hover:bg-brand-600  dark:border-gray-800 dark:bg-brand-500 dark:text-white dark:hover:bg-brand-600 dark:hover:text-white'
            >
                <Plus className='w-5 h-5' />
            </button>

            <Dropdown
                isOpen={isOpen}
                onClose={closeDropdown}
                className='absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark z-50'
            >
                <h4 className='px-4 py-3 text-lg font-semibold text-gray-800 dark:text-gray-200'>Novo Registro</h4>

                <ul className='flex flex-col gap-1 pb-3 '>
                    <li className='relative'>
                        <div className='flex items-center justify-between gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm dark:text-gray-400'>
                            <div className='flex items-center gap-3'>
                                <Kanban className='w-5 h-5' />
                                Negócios
                            </div>
                            <ChevronDown className='w-4 h-4' />
                        </div>
                        <ul className='ml-6 mt-1 flex flex-col gap-1'>
                            <li>
                                <DropdownItem
                                    onItemClick={closeDropdown}
                                    onClick={() => {
                                        setCurrentTabBusiness('tab1')
                                        setCurrentStep(null)
                                        setOpenBusiness(true)
                                    }}
                                    tag='a'
                                    href='/negocio'
                                    className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                                >
                                    <Rocket className='w-5 h-5' />
                                    Vendas
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem
                                    onItemClick={closeDropdown}
                                    onClick={() => {
                                        setCurrentTabBusiness('tab2')
                                        setCurrentStep(null)
                                        setOpenBusiness(true)
                                    }}
                                    tag='a'
                                    href='/negocio'
                                    className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                                >
                                    <Key className='w-5 h-5' />
                                    Locação
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem
                                    onItemClick={closeDropdown}
                                    onClick={() => {
                                        setCurrentTabBusiness('tab3')
                                        setCurrentStep(null)
                                        setOpenBusiness(true)
                                    }}
                                    tag='a'
                                    href='/negocio'
                                    className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                                >
                                    <Users className='w-5 h-5' />
                                    Equipe
                                </DropdownItem>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            tag='a'
                            href='/contato'
                            onClick={() => setOpenContact(true)}
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <UserCheck className='w-5 h-5' />
                            Contato
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            tag='a'
                            href='/empresa'
                            onClick={() => setOpenCompany(true)}
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <Building2 className='w-5 h-5' />
                            Empresa
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            tag='a'
                            href='/produto'
                            onClick={() => setOpenProduct(true)}
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <ShoppingCart className='w-5 h-5' />
                            Produto
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            onClick={() => {
                                setCurrentTabActivity('tab2') //? Atividade => Tab Tarefas
                                setOpenTask(true)
                            }}
                            tag='a'
                            href='/atividade'
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <SquareCheckBig className='w-5 h-5' />
                            Tarefa
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            onClick={() => {
                                setCurrentTabActivity('tab3') //? Atividade => Tab Eventos
                                setOpenEvent(true)
                            }}
                            tag='a'
                            href='/atividade'
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <Presentation className='w-5 h-5' />
                            Evento
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            onClick={() => {
                                setCurrentTabActivity('tab4') //? Atividade => Tab Chamadas
                                setOpenCall(true)
                            }}
                            tag='a'
                            href='/atividade'
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <Phone className='w-5 h-5' />
                            Chamada
                        </DropdownItem>
                    </li>
                    <li>
                        <DropdownItem
                            onItemClick={closeDropdown}
                            tag='a'
                            // href='/profile'
                            className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300'
                        >
                            <Truck className='w-5 h-5' />
                            Entrega
                        </DropdownItem>
                    </li>
                </ul>
            </Dropdown>
        </div>
    )
}
